import { Button } from '@mui/material';
import React, { useEffect, useState, useMemo } from 'react';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import { DietaDetalle } from './DietaDetalle';
import EmptyGridSvg from '../../../../assets/svg/EmptyGridInsumo.svg';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import { PopoverModal } from '../../../../components/popoverModal/PopoverModal';


import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import EditIcon from '@mui/icons-material/Edit';
import toast, { Toaster } from 'react-hot-toast';

import './stepDietas.scss';

export const StepDietas = ({ stepsData, setStepsData }) => {

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const elecciones = [
        {
            id: 1,
            displayName: "1ra",
            name: "1ra"
        },
        {
            id: 2,
            displayName: "2da",
            name: "2da"
        },
        {
            id: 3,
            displayName: "3ra",
            name: "3ra"
        },
        {
            id: 4,
            displayName: "4ta",
            name: "4ta"
        },
        {
            id: 5,
            displayName: "5ta",
            name: "5ta"
        },
        {
            id: 6,
            displayName: "6ta",
            name: "6ta"
        }
    ];
    const [editRow, setEditRow] = useState({});

    const handleEditRowClick = (editDieta) => {
        setEditRow(editDieta);
        setModalIsOpen(true);
    }

    const handleDeleteRowClick = (row) => {
        setStepsData(previousData => ({
            ...previousData,
            dietas: [...previousData.dietas.filter(c => c.id !== row.id)]
        }));
    }

    const isValidDieta = (dieta) => {
        if (dieta.eleccion <= 0) {
            toast.error('Debe seleccionar una elección.');
            return false;
        }

        return true;
    }

    const handleRowClick = (newDieta) => {
        if (isValidDieta(newDieta)) {
            const newDietasSelected = [...(stepsData.dietas || []), newDieta];
            setStepsData(previousData => ({
                ...previousData,
                dietas: [...newDietasSelected.map((dieta, index) => ({ ...dieta, id: index }))]
            }));
            setEditRow({});
            setModalIsOpen(false);
        }
    }

    const handleEditSaveRowClick = (editDieta) => {
        if (isValidDieta(editDieta)) {
            const newDietasSelected = [...(stepsData.dietas || []).filter(c => c.id !== editDieta.id), editDieta];
            setStepsData(previousData => ({
                ...previousData,
                dietas: [...newDietasSelected]
            }));
            setModalIsOpen(false);
        }
    }

    const handleAddDietaClick = () => {
        setEditRow({});
        setModalIsOpen(true);
    }
    const initialColumns = [
        {
            field: 'eleccion',
            headerName: 'Elección',
            valueGetter: (eleccion) => elecciones.find(sc => sc.id == eleccion)?.displayName
        },
        {
            headerName: '',
            field: 'action',
            flex: 0.02,
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    <>
                        <PopoverModal>
                            <div className='popover-modal-content'>
                                <div
                                    onClick={() => handleEditRowClick(row)} aria-hidden='true'
                                    className='item-option clickable-option'
                                >
                                    <EditIcon className='edit-icon' />
                                    <span className='toggle-action'>Editar</span>
                                </div>
                                <div
                                    onClick={() => handleDeleteRowClick(row)} aria-hidden='true'
                                    className='item-option clickable-option'
                                >
                                    <DeleteOutlineIcon className='edit-icon' />
                                    <span className='toggle-action'>Eliminar</span>
                                </div>
                            </div>
                        </PopoverModal>
                    </>
                )
            }
        }
    ];
    const columns = generateColumnsDefaultConfiguration(initialColumns);

    useEffect(() => {
        const newDietasSelected = [...(stepsData.dietas || [])];
        setStepsData(previousData => ({
            ...previousData,
            dietas: [...newDietasSelected.map((dieta, index) => ({ ...dieta, id: index }))]
        }));
    }, [])

    return (
        <div className='step-dietas'>

            {
                stepsData?.dietas.length == 0 &&
                <div className='empty-grid'>
                    <img className='empty-grid-svg' src={EmptyGridSvg} width="100%"></img>
                    <p>No se ha agregado ninguna elección</p>
                    <CustomButton
                        variant={'contained'}
                        onClick={() => handleAddDietaClick()}
                        size={'small'}
                    >
                        Agregar Elección
                    </CustomButton>
                </div>
            }

            {
                stepsData?.dietas.length > 0 &&
                <>
                    <div className='button-add-dieta-grid'>
                        <CustomButton
                            variant='contained'
                            onClick={handleAddDietaClick}
                            disableElevation
                            size='small'
                            disabled={stepsData?.dietas.length > 0}
                        >
                            Agregar Elección
                        </CustomButton>
                    </div>
                    <DataGridGenerico
                        hideFooterPagination={true}
                        toolbar={false}
                        columns={columns}
                        rows={stepsData?.dietas}
                    />
                </>
            }

            <DietaDetalle
                open={modalIsOpen}
                onClose={() => setModalIsOpen(false)}
                onRowClick={handleRowClick}
                rowData={editRow}
                elecciones={elecciones}
                onEditRowClick={handleEditSaveRowClick}
            />
        </div>
    )
}